
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MasterService } from '../../../../services/master.service'
import { MessageService } from '../../../../services/message.service'
import { StoreService } from '../../../../services/store.service'
import { Router, ActivatedRoute } from '@angular/router';
import * as languageLibrary from '../../../../services/language'
import { SEARCH_DEBOUNCE_MILLIS, MIN_SEARCH_CHARS } from 'src/app/constants/list';
import { Address } from 'src/app/models/address.model';
import { ADDRESS_OWNERSHIP, ADDRESS_TYPES } from 'src/app/constants/contact';
import { AddressType } from 'src/app/models/address-type.model';

@Component({
    selector: 'addresses-corporate',
    templateUrl: './addresses.component.html',
    styleUrls: ['./addresses.component.scss'],
    standalone: false
})
export class AddressesCorporateComponent implements OnChanges {
    /*
    * variables
    */

    // save the language
    @Input() language: string = 'EN'

    //  implement corporate object
    @Input() corporate: Object = {}

    // Unique internal identity of the associated contact
    @Input() contactId: number = 0

    // Let the parent know one or more addresses were added/modified.
    @Output() addressChanged$: EventEmitter<Object> = new EventEmitter()

    // set all words
    protected words = languageLibrary.language

    // define the selected address
    protected addressSelected: number = 0

    // define the address selected
    protected selected: number = 0

    // save all addresses
    protected addressesList: Address[] = []

    // save the types
    protected types: AddressType[] = ADDRESS_TYPES

    // save the rent or own
    protected rentOwn: string[] = ADDRESS_OWNERSHIP

    // define the contact type
    protected type: string = ''

    //  define if some changes not saved
    protected savePending: boolean = false

    // define the contact type
    protected id: number = 0

    // define if loading state
    protected loading: boolean = false

    // zip code list
    protected zipCodeList: Address[] = []

    // latest search inquiry
    protected zipInquiry = null

    protected timeOutID: ReturnType<typeof setTimeout>

    // address payload
    protected addressPayload: Address[] = [];

    // addresslokup
    protected addressLookup: Object = {
        city: "",
        county: "",
        state: "",
        zipcode: "",
        country: ""
    }

    protected expanded: boolean = false

    // Group of inputs
    protected information = new FormGroup({
        contactId: new FormControl<number>(0, [Validators.required]),
        id: new FormControl<number>(0),
        addressTypeId: new FormControl<number>(this.types.find((type) => type['type'].toLocaleLowerCase() === 'mailing')['id'], [Validators.required]),
        status: new FormControl<string>('other', [Validators.required]),
        address: new FormControl<string | null>(null, [Validators.required]),
        address2: new FormControl<string | null>(null, []),
        zipCode: new FormControl<string | null>(null, [Validators.required, Validators.pattern('[0-9]{3,10}')]),
        city: new FormControl<string | null>(null, [Validators.required]),
        state: new FormControl<string | null>(null, [Validators.required]),
        county: new FormControl<string | null>(null, []),
        country: new FormControl<string | null>(null, []),
        primaryAddress: new FormControl<boolean>(false, [])
    })

    // get information of inputs
    get address() { return this.information.get('address') }
    get address2() { return this.information.get('address2') }
    get zipCode() { return this.information.get('zipCode') }


    /*
    * Life cicles
    */
    constructor(private master: MasterService, private ms: MessageService, private route: ActivatedRoute, private store: StoreService) { }

    ngOnInit() {
        this.type = this.route.snapshot.params['type']
        this.id = parseInt(this.route.snapshot.params['id'])

        if (isNaN(this.contactId) || (this.contactId <= 0)) {
            return
        }

        this.information.get('contactId').setValue(this.contactId)
        this.getAddresses()
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!changes) {
            return
        }

        if (changes.contactId) {
            this.information.get('contactId').setValue(this.contactId)
            this.getAddresses()
            return
        }
    }

    /*
    * functions
    */
    // clean Fields
    protected cleanFields = (clearPayload: boolean): void => {
        if (clearPayload) {
            this.addressPayload = []
        }

        this.zipCodeList = []
        this.information.reset()

        this.information.patchValue({
            contactId: this.contactId,
            addressTypeId: this.types.find((type) => type.type.toLowerCase() === 'mailing').id,
            status: 'other',
        })
    }
    /*
    ?: create
    */
    // save
    protected save = (closeAfter: boolean): void => {
        if (this.information.invalid) {
            return
        }

        if (!this.addressesList || (this.addressesList.length <= 0)) {
            this.information.get('primaryAddress').setValue(true)
        }

        const addy = JSON.parse(JSON.stringify(this.information.value))
        this.addressPayload.push(addy)
        this.loading = true

        //  save address
        this.master.post(`contacts/${this.contactId}/addresses`, { addresses: this.addressPayload }, res => {
            this.loading = false
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.savePending = false
            // close modal
            const btn = (document.getElementById('btn-cancel-addresses') as HTMLButtonElement)
            if (closeAfter && btn) {
                btn.click()
            }

            // clean the fields
            this.cleanFields(true)
            this.getAddresses()

            this.addressChanged$.emit(addy)
        })
    }

    /*
    todo: update
    */
    // save
    protected modifyAddress = (address: Object): void => {
        if (this.address.invalid) {
            return
        }

        const addy = JSON.parse(JSON.stringify(this.information.value))
        this.loading = true

        this.master.put(`contacts/${this.contactId}/addresses/${address['id']}`, {address: addy}, res => {
            this.loading = false

            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            // close modal
            const btn = (document.getElementById('btn-close-addresses-update') as HTMLButtonElement)
            if (btn) {
                btn.click()
            }

            // clean the fields
            this.cleanFields(true)
            this.getAddresses()

        })

    }

    protected getAddress = (addressId: number): void => {
        this.master.get(`contacts/${this.contactId}/addresses/${addressId}`, res => {
            this.loading = false
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.setFormInfo(res.data.address)

        })
    }

    // select address update
    protected setFormInfo = (address: Object): void => {
        this.information.setValue({
            addressTypeId: address['addressTypeId'],
            address: address['address'],
            address2: address['address2'],
            zipCode: address['zipCode'],
            city: address['city'],
            state: address['state'],
            county: address['county'],
            country: address['country'],
            id: address['id'],
            contactId: this.contactId,
            status: (address['status'] || 'other').toLocaleLowerCase(),
            primaryAddress: address['primaryAddress'] || false
        })
    }
    // select address
    protected selectAddress = (addressId: number): void => {
        this.addressSelected = addressId
    }

    /*
    ! delete
    */
    protected delete = (): void => {
        this.loading = true

        this.master.discard(`contacts/${this.contactId}/addresses/${this.addressSelected}`, res => {
            this.loading = false
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            const btn = (document.getElementById('close-delete-modal') as HTMLButtonElement)
            if (btn) {
                btn.click()
            }

            // clean the fields
            this.cleanFields(true)
            this.getAddresses()
        })
    }
    /*
    * select defaul
    */
    // define the address default
    protected selectDefault = (id: number): void => {
        if (!id) {
            return
        }

        const identity = id
        if (isNaN(identity) || (identity <= 0)) {
            this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
            return
        }

        this.master.patch(`contacts/${this.contactId}/addresses/${id}/primary`, null, res => {
            this.loading = false

            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.getAddresses()
        })
    }

    // ? address lookup
    // verify if the corporate is already exist
    protected searchZipCode(): void {
        const code = this.information.get('zipCode').value
        if (!code || code.length < MIN_SEARCH_CHARS) {
            return
        }

        if (this.zipInquiry && (code === this.zipInquiry)) { // hasn't changed?
            return
        }

        clearTimeout(this.timeOutID)

        this.timeOutID = setTimeout(() => {
            this.zipCodeList = []
            this.zipInquiry = code

            this.master.get(`readLocationByZipcode?zipcode=${code}`, res => {
                if (!res) {
                    this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                    return
                }

                if (res.status !== 200) {
                    return
                }

                this.zipCodeList = res.data.locations

                // autocomplete
                if ((code.length >= 5) && (this.zipCodeList.length === 1)) {
                    this.selectZipCode(this.zipCodeList[0])
                }
            })
        }, SEARCH_DEBOUNCE_MILLIS);

        /**/
    }

    /**
    * Handle zip code changes
    * @param address Zip code meta data containing address information.
    */
    protected selectZipCode = (address: Object): void => {
        if (!address || !this.information) {
            return
        }

        this.information.get('city').setValue(address['city'])
        this.information.get('state').setValue(address['state'])
        this.information.get('county').setValue(address['county'])
        this.information.get('zipCode').setValue(address['zipcode'])
        this.information.get('country').setValue('United States')

        this.zipCodeList = []
    }

    // open the location
    protected openLocation = (address: string, county: string, state: string): void => {
        address = address.replace(' ', '+')
        county = county.replace(' ', '+')
        state = state.replace(' ', '+')
        console.info(`https://www.google.com/maps/search/?api=1&query=${address}+${county}+${state}`);

        window.open(`https://www.google.com/maps/search/?api=1&query=${address}+${county}+${state}`, '_blank')
    }

    // find primary address
    protected findPrimaryAddress = (): void => {
        if (this.corporate['addresses']) {
            let primary = this.corporate['addresses'].filter(el => el.primaryAddress == 1)
            if (primary.length > 0) {
                this.selected = primary[0].id
            }
        }
    }

    private getAddresses() {
        if (isNaN(this.contactId) || (this.contactId <= 0)) {
            return
        }

        this.master.get(`contacts/${this.contactId}/addresses`, res => {
            this.loading = false
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.addressesList = res.data.addresses
        })
    }

    protected add = (addressToSave: any): void => {
        this.addressPayload.push(addressToSave)
        this.cleanFields(false)
    }

}
